import Check from "./operation-panel-button/check.jsx";
import Submit from "./operation-panel-button/submit.jsx";
import Maximize from "./operation-panel-button/maximize.jsx";
import Exit from "./operation-panel-button/exit.jsx";
import CountDown from "./operation-panel-button/count-down.jsx";
import { getCountDownTime, getCanBeShare } from '../../lib/xes/xes.js'
import xesAssistant from '../../lib/xes/xesAssistant'
import { sessionStore } from '../../lib/xes/local-store'
import styles from "./panel.css";

import React, { useState } from 'react'
import ClassworkModal from '../classwork-modal/classwork-modal'
import { getXesEnvHanlder } from '../../lib/xes/xes'

// 引入检查弹窗
import CheckLayer from '../check-layer/check-layer.jsx';

import SmartLayer from '../smartFB/smart-layer.jsx';

export let baizeGoldModal;

const answer_url = sessionStore.get('answer_url')
const isAnswer = answer_url && answer_url.includes('after/answer')

export default () => {
    const [isModalOpen, setIsModalOpen] = useState(false)
    const [goldUrl, setGoldUrl] = useState('')
    baizeGoldModal = {
        toggle(isOpen, url) {
            if (url) {
                setGoldUrl(url)
            }
            setIsModalOpen(isOpen)
        }
    }
    const handler = getXesEnvHanlder()
    handler.setModal(baizeGoldModal)

    return (<div className="panel">
        <ClassworkModal
            isOpen={isModalOpen}
            close={() => setIsModalOpen(false)}
            goldUrl={goldUrl}
            canBeShare={getCanBeShare()}
        />
        <CountDown countDownTime={getCountDownTime()} />
        <CheckLayer />
        <SmartLayer />
        {
            xesAssistant.isPc() ? 
            <React.Fragment>
                <Check />
                <Submit className={'hide'}/>
                <Maximize />
            </React.Fragment>
            :
            <React.Fragment>
                <Check />
                <Submit className={isAnswer ? '' : 'hide'}/>
                <Exit/>
            </React.Fragment>
        }
    </div>)
};
